// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 显示语言枚举 枚举类
 * 显示语言枚举
 */
export enum EnumDisplayLanguage {
  /** 中文 : 中文 */
  Chinese = 1,
  /** 英文 : 英文 */
  English = 2
}

/**
 * 显示语言枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumDisplayLanguageMD {
  private static items = [
    new EnumItemMD('Chinese', 1, '中文', '中文'),
    new EnumItemMD('English', 2, '英文', '英文')
  ];

  static getItem(enumItem: EnumDisplayLanguage) {
    return this.items.find(item => item.name === EnumDisplayLanguage[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
